// Business mappers
import {
  isAvailable,
  customsProductKeys,
  customsPromotionKeys,
  customsGA4Keys,
  productKeysGA4,
  promotionKeysGA4,
  GA4ProductKeyList,
  GA4PromotionKeyList,
} from "../../../business/mappers/productDimensions";

import warn from "../../../utils/warn";

/**
 * UA Builder of custom dimension/metrics for ecommerce payload.
 * @param {object} originalPayload Payload sent from the app who calls track in
 * @param {string} type Type of payload being sent: product, promotion
 * the product object
 * @return {object}
 */
export const buildEcommerceCustoms = (originalPayload, type) => {
  const payload = {};
  const keys = type == "product" ? customsProductKeys : customsPromotionKeys;
  // Using GA4 list for validation only
  // eslint-disable-next-line max-len
  const availableKeys =
    type == "product" ? GA4ProductKeyList : GA4PromotionKeyList;
  const customs = {};
  // Whitelisted keys
  // eslint-disable-next-line prefer-const
  for (let [key, value] of Object.entries(originalPayload)) {
    if (availableKeys.indexOf(key) != -1) {
      payload[key] = value;
    }
  }
  // Translate custom keys
  if (originalPayload.custom) {
    // eslint-disable-next-line prefer-const
    for (let [key, value] of Object.entries(originalPayload.custom)) {
      if (isAvailable(key)) {
        customs[keys(key)] = value;
      } else {
        warn(`The key ${key} is not available as ${type} dimension.`);
      }
    }
  }
  return {
    ...payload,
    ...customs,
  };
};

/**
 * GA4 Builder of custom dimension/metrics for ecommerce payload.
 * @param {object} originalPayload Payload sent from the app who calls track in
 * @param {string} type Type of payload being sent: product, promotion
 * the product object
 * @return {object}
 */
export const buildGA4EcommerceCustoms = (originalPayload, type) => {
  const payload = {};
  const keys = (type === "product") ? productKeysGA4 : promotionKeysGA4;
  // eslint-disable-next-line max-len
  const customKeys = customsGA4Keys;
  // eslint-disable-next-line max-len
  const availableKeys = [...GA4ProductKeyList , ...GA4PromotionKeyList];
  const customs = {};
  // Translate keys
  // eslint-disable-next-line prefer-const
  for (let [key, value] of Object.entries(originalPayload)) {
    if (availableKeys.indexOf(key) != -1) {
      payload[keys(key)] = value;
    }
  }
  // Translate custom keys
  if (originalPayload.custom) {
    // eslint-disable-next-line prefer-const
    for (let [key, value] of Object.entries(originalPayload.custom)) {
      if (isAvailable(key)) {
        customs[customKeys(key)] = value;
      } else {
        warn(`The key ${key} is not available as ${type} dimension.`);
      }
    }
  }
  return {
    ...payload,
    ...customs,
  };
};
